<template>
    <div>
        <b-modal ref="modal-generate-root-operation-balance">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center"><h3>{{ __('generate_balance')}}</h3></div>
                    <div class="col-md-1">
                        <button type="button" class="close" @click="hideModal()">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default="{}">
                <h3>Wyksięgowanie tej płatności spowoduje jej przeniesienie do historii źródłowego kontrahenta.</h3>
                <h3>Wykonać?</h3>
            </template>

            <template v-slot:modal-footer="{}">
                <button type="button" class="btn btn-white" @click="hideModal()" :disabled="submitted">{{ __('cancel')}}</button>
                <button type="button" class="btn btn-primary" @click="generateBalance()" :disabled="submitted">{{ __('save')}}</button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import events from './../../services/Events.js'
    import actions from './../../vuex/modal_generate_root_operation_balance/action_types.js'
    import actions_lock from './../../vuex/contractor_history/action_types.js'
    export default {
        name: "modal-generate-root-operation-balance",
        data: function () {
            return {
                submitted: false,
            }
        },
        methods: {
            showModal() {
                this.$refs['modal-generate-root-operation-balance'].show()
            },
            hideModal() {
                let input_data = {
                    operations: this.$store.getters.getSelectedOperations,
                    documents: this.$store.getters.getSelectedDocuments
                };
                this.$store.dispatch(actions_lock.DELETE_LOCKS, input_data)
                this.$refs['modal-generate-root-operation-balance'].hide()
            },
            getSelectedOperation() {
                const selected = this.$store.getters.getSelected;

                if(selected.length === 1
                    && selected[0].source_type === 'OPERATION'
                    && selected[0].operation_root_is_global == 1
                ) {
                    return selected[0];
                } else {
                    throw new Error('selected operation cannot be subject to this action, or no operation selected')
                }
            },
            generateBalance() {
                const operation = this.getSelectedOperation();
                this.submitted = true;
				events.$emit('modalGenerateBalance:saving');
                this.$store.dispatch(actions.MODAL_GENERATE_ROOT_OPERATION_BALANCE_SAVE, { operation: operation })
                    .then(response => {
                        window.location.reload();
                    })
                    .catch(error => {
                        console.log(error.response.data.message);
                        toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                        this.submitted = false;
                    });
                this.hideModal();
            }
        },
        mounted: function() {
            const self = this;
            events.$on('generateSourceContractorBalanceModal:hide', this.hideModal);
        },
    }
</script>

<style scoped>

</style>
